import React, { useState } from 'react';
import KubitTooltip from '../KubitTooltip';
import { SvgIcon } from '../Icon';
import * as SecondaryNavUI from './SecondaryNavUI';
import SecondaryNavRouteLink from './SecondaryNavRouteLink';
import PermissionElementWrapper from '../../pages/PermissionControls/PermissionElementWrapper';
import { ISidebarLink } from '../../path';
import styled from 'styled-components';

type ISecondaryNavLink = Pick<
  ISidebarLink,
  'url' | 'title' | 'icon' | 'tooltip'
> & {
  isPermitted?: boolean;
};

interface IProps {
  links: ISecondaryNavLink[];
  onClick?: () => void;
}

type ISecondaryNavLinkProps = ISecondaryNavLink & {
  mouseOverLink: string;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`;

const SecondaryNavLink = ({
  url,
  title,
  icon,
  mouseOverLink,
}: ISecondaryNavLinkProps) => (
  <SecondaryNavRouteLink url={url} mouseOverLink={mouseOverLink}>
    <SecondaryNavUI.StyledNavItem $isInteractive={true}>
      {icon && (
        <SvgIcon name={icon} width={20} height={20} customFill="currentColor" />
      )}
      {title}
    </SecondaryNavUI.StyledNavItem>
  </SecondaryNavRouteLink>
);

export default ({ links, onClick }: IProps) => {
  const [mouseOverLink, setMouseOverLink] = useState('');

  return (
    <Container>
      {links.map(({ isPermitted, title, url, icon, tooltip }) => {
        return (
          <PermissionElementWrapper
            key={`${url}-secondary-nav-link`}
            isPermitted={isPermitted === undefined || isPermitted}
          >
            <KubitTooltip
              placement="right"
              noOpenDelay={true}
              // must use isPermitted === false to prevent !undefined === true
              disabled={!tooltip || isPermitted === false}
              {...tooltip}
            >
              <SecondaryNavUI.LinkContainer
                onMouseEnter={() => setMouseOverLink(url)}
                onMouseLeave={() => setMouseOverLink('')}
                $isDisabled={isPermitted === false}
                onClick={onClick}
              >
                <SecondaryNavLink
                  url={url}
                  title={title}
                  icon={icon}
                  mouseOverLink={mouseOverLink}
                />
              </SecondaryNavUI.LinkContainer>
            </KubitTooltip>
          </PermissionElementWrapper>
        );
      })}
    </Container>
  );
};
